<template>
  <div class="page">
    <div class="page--section">
      <header-bar-mobile/>
      <div class="header">
        <header-bar/>
      </div>
      <transition appear name="title">
        <heading type="h1">
          <slot name="title"/>
        </heading>
      </transition>
      <transition appear name="content">
        <div class="page--content">
          <slot name="section"/>
        </div>
      </transition>
    </div>
    <transition appear name="fromOpacity">
      <div class="page--aside">
        <sticky><slot name="aside"/></sticky>
      </div>
    </transition>
  </div>
</template>

<script>
import Sticky from '@/components/Sticky';
import Heading from '@/components/Heading';
import HeaderBar from '@/components/HeaderBar';
import HeaderBarMobile from '@/components/HeaderBarMobile';
export default {
  components: {
    HeaderBar,
    HeaderBarMobile,
    Heading,
    Sticky,
  },
  mounted () {
    this.$el.setAttribute('class', `${this.$el.getAttribute('class')}${this.$route.name === 'home' ? ' page-home' : ''} `)
  }
}
</script>


<style lang="scss">
.page {
  display: flex;
  flex-wrap: nowrap;
  min-height: 900px;
  @media (max-width: 767px) {
    min-height: 0;
  }

  &-home {
    min-height: 600px;
    @media (max-width: 767px) {
      min-height: 0;
    }
    .page--section {
      display: flex;
      flex-direction: column;
    }
  }

  &--content {
    position: relative;
    flex: 1 1 auto;
  }

  &--section {
    position: relative;
    flex: 0 0 840px;
    padding: 40px 18px 50px 70px;
  }
  &--aside {
    flex: 1 1 auto;
  }
}
.title-enter-active {
  transition: all .3s ease;
}
.title-enter, .title-leave-to {
  transform: translateY(30px);
  opacity: 0;
}
.content-enter-active {
  transition: all .3s ease .2s;
}
.content-enter, .content-leave-to {
  transform: translateY(50px);
  opacity: 0;
}
.fromOpacity-enter-active {
  transition: all .6s ease;
}
.fromOpacity-enter, .fromOpacity-leave-to {
  opacity: 0;
}
.header {
  margin: 0 0 50px;
}

@media (max-width: 767px) {
  .page {
    display: block;

    &--section {
      width: 100%;
      padding: 0 10px;
      min-width: 0;
    }
    &--aside {
      width: 100%;
    }
  }
  .header {
    overflow: auto;
    position: fixed;
    top: 48px;
    bottom: calc(100% - 48px);
    left: 0;
    right: 0;
    background: #fff;
    z-index: 100;
    padding: 0 10px;
    transition: all .45s ease-out;
    .column:first-child {display: none;}
  }
  body.openPopup {
    height: 100vh;
    overflow: hidden;
    .header {
      bottom: 0;
      padding: 30px 10px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Page.vue?7614aa93